export default __webpack_public_path__ + "static/media/7077BLEU.fb95f47e.pdf";